export const token_addresses = {
  emojiFlagAddress:"0x5E5713a0d915701F464DEbb66015adD62B2e6AE9"
}
